import React, { useCallback } from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { ADMIN_ACCESS_LINKS, HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { AccessLinkSiteAdminConfigurationLoader } from '@confluence/access-links/entry-points/AccessLinkSiteAdminConfigurationLoader.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminAccessLinksConfigurationRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		sideNavigationId: string;
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => {
	const { push } = useRouteActions();

	const handleBack = useCallback(() => push(ADMIN_ACCESS_LINKS.toUrl()), [push]);

	if (!expValEquals('shareable_links_m0', 'isEnabled', true)) {
		return <Redirection name={HOME.name} />;
	}

	return <AccessLinkSiteAdminConfigurationLoader onBack={handleBack} />;
};

AdminAccessLinksConfigurationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	sideNavigationId: string;
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'siteSettingsAccessLinksConfigurationScreen' },
	},
	sideNavigationId: ADMIN_HOME_ID,
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
